import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../apiWithAccessToken";




const getFileExtension = (filename) =>
  filename.split(".").pop().toLowerCase();

const getTotalSizeMB = (files) =>
  files.reduce((sum, f) => sum + f.size, 0) / 1024 / 1024;


const MAX_FILE_SIZE_MB = 25;

const ALLOWED_EXTENSIONS = [
  "txt", "pdf", "png", "jpg", "jpeg", "gif",
  "mp3", "wav", "mp4", "mov",
  "doc", "docx", "ppt", "pptx"
];


const SupportScreen = () => {
  const [activeTab, setActiveTab] = useState("create");

  // form state (UI only)
  const [message, setMessage] = useState("");
  const [mainCategory, setMainCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [files, setFiles] = useState([]);

  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [tickets, setTickets] = useState([]);
  const [loadingTickets, setLoadingTickets] = useState(false);
  const [expandedTicket, setExpandedTicket] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);


  useEffect(() => {
  document.body.style.overflow = showConfirmModal ? "hidden" : "auto";
  return () => {
    document.body.style.overflow = "auto";
  };
}, [showConfirmModal]);


  useEffect(() => {
  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const res = await api.get("/support/categories");
            console.log("CATEGORIES API:", res.data); // 👈 ADD THIS

      setCategories(res.data.categories || []);
    } catch (err) {
      console.error("CATEGORY ERROR:", err);
      toast.error("Failed to load support categories");
    } finally {
      setLoadingCategories(false);
    }
  };

  fetchCategories();
}, []);

useEffect(() => {
  if (activeTab !== "history") return;

  const fetchTickets = async () => {
    try {
      setLoadingTickets(true);
      const res = await api.get("/support/history");
      setTickets(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load ticket history");
    } finally {
      setLoadingTickets(false);
    }
  };

  fetchTickets();
}, [activeTab]);

const selectedCategoryObj = categories.find(
  c => c.category === mainCategory
);

const subcategories = selectedCategoryObj?.subcategories || [];


const isFormValid =
  mainCategory &&
  message.trim() &&
  !submitting &&
  !loadingCategories;

const removeFile = (index) => {
  setFiles(prev => prev.filter((_, i) => i !== index));
};



const resetForm = () => {
  setMainCategory("");
  setSubCategory("");
  setMessage("");
  setFiles([]);

  const fileInput = document.querySelector('input[type="file"]');
  if (fileInput) fileInput.value = "";
};


  const handleSubmitTicket = async () => {
   
    if (submitting) return;
    
  if (!mainCategory) {
    toast.error("Please select a category");
    return;
  }

  if (!message.trim()) {
    toast.error("Please enter a message");
    return;
  }



  const formData = new FormData();
 formData.append("main_category", mainCategory);
formData.append("sub_category", subCategory);
formData.append("message", message);

 files.forEach(file => {
  formData.append("attachments", file);
});
  try {
    setSubmitting(true);

    await api.post("/support/create-ticket", formData);

    toast.success("Ticket created successfully");

    // reset form
    //setCategory("");
    //setMessage("");
   // setFile(null);
   resetForm();

  } catch (err) {
    console.error(err);
    toast.error(
      err.response?.data?.msg || "Failed to create support ticket"
    );
  } finally {
    setSubmitting(false);
  }
};




  return (
    <div className=" no-scrollbar bg-background text-foreground flex flex-col h-full overflow-y-auto">
      <div className="flex-1 px-4 py-6">

        <h1 className="text-xl font-semibold mb-6">Help & Support</h1>

        {/* Tabs */}
        <div className="flex gap-4 border-b border-border mb-6">
          <button
            onClick={() => setActiveTab("create")}
            className={`pb-2 text-sm font-medium ${
              activeTab === "create"
                ? "border-b-2 border-primary text-primary"
                : "text-muted-foreground"
            }`}
          >
            Create Ticket
          </button>

          <button
            onClick={() => setActiveTab("history")}
            className={`pb-2 text-sm font-medium ${
              activeTab === "history"
                ? "border-b-2 border-primary text-primary"
                : "text-muted-foreground"
            }`}
          >
            My Tickets
          </button>
        </div>

        {/* Create Ticket */}
        {activeTab === "create" && (
          <div className="space-y-4">

            {/* Category */}
            {/* Main Category */}
<div>
  <label className="block text-sm font-medium mb-1">
    Main Category
  </label>
  <select
    value={mainCategory}
    onChange={(e) => {
      setMainCategory(e.target.value);
      setSubCategory(""); // reset subcategory
    }}
    className="w-full border border-border rounded-md px-3 py-2 bg-background"
  >
    <option value="">Select category</option>
    {categories.map((cat) => (
      <option key={cat.category} value={cat.category}>
        {cat.category}
      </option>
    ))}
  </select>
</div>

{/* Sub Category */}
{subcategories.length > 0 && (
  <div>
    <label className="block text-sm font-medium mb-1">
      Sub Category (optional)
    </label>
    <select
      value={subCategory}
      onChange={(e) => setSubCategory(e.target.value)}
      className="w-full border border-border rounded-md px-3 py-2 bg-background"
    >
      <option value="">Select sub category</option>
      {subcategories.map((sub) => (
        <option key={sub} value={sub}>
          {sub}
        </option>
      ))}
    </select>
  </div>
)}


            {/* Message */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Message
              </label>
              <textarea
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full border border-border rounded-md px-3 py-2 bg-background"
                placeholder="Describe your issue..."
              />
            </div>

            {/* Attachment */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Attachment (optional)
              </label>
              <input
           type="file"
          multiple

    onChange={(e) => {
  const selectedFiles = Array.from(e.target.files);

  // merge with existing files
  const combinedFiles = [...files, ...selectedFiles];

  // validate extensions
  for (let file of combinedFiles) {
    const ext = getFileExtension(file.name);
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
      toast.error(`File type .${ext} not allowed`);
      return;
    }
  }

  // validate total size (ALL files together)
  const totalMB = getTotalSizeMB(combinedFiles);
  if (totalMB > MAX_FILE_SIZE_MB) {
    toast.error(`Total attachment size exceeds ${MAX_FILE_SIZE_MB} MB`);
    return;
  }

  setFiles(combinedFiles);

  //  VERY IMPORTANT: reset input so same file can be reselected
  e.target.value = "";
}}


        className="text-sm"
/>

              <p className="text-xs text-muted-foreground mt-1">
                Allowed types: pdf, images, video, docs (max 25 MB)
                 </p>
{files.length > 0 && (
  <div className="mt-2 space-y-2">
    {files.map((file, index) => (
      <div
        key={index}
        className="flex items-center justify-between text-xs border border-border rounded-md px-3 py-2 bg-muted"
      >
        <div className="truncate">
          <span className="font-medium">{file.name}</span>
          <span className="ml-2 text-muted-foreground">
            ({(file.size / 1024 / 1024).toFixed(2)} MB)
          </span>
        </div>

        <button
          onClick={() => removeFile(index)}
          className="text-red-500 hover:text-red-600 text-xs font-medium"
        >
          ✕
        </button>
      </div>
    ))}

    <p className="text-[11px] text-muted-foreground">
      Total: {getTotalSizeMB(files).toFixed(2)} / {MAX_FILE_SIZE_MB} MB
    </p>
  </div>
)}




            </div>

            {/* Submit */}
            <button
              onClick={() => setShowConfirmModal(true)}
              disabled={!isFormValid}
             className={`px-4 py-2 rounded-md text-sm  font-medium transition-colors ${
              isFormValid
               ? "bg-primary text-primary-foreground hover:bg-primary/90 cursor-pointer"
               : "bg-blue-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400 cursor-not-allowed"
                }`}
            >
              {submitting ? "Submitting..." : "Submit Ticket"}
            </button>

             {!isFormValid && (
             <p className="text-xs text-muted-foreground mt-2">
                Please select a category and enter a message to submit.
             </p>
             )}

           </div>
        )}

        {activeTab === "history" && (
      <div className="space-y-4">

    {loadingTickets && (
      <p className="text-sm text-muted-foreground">
        Loading tickets...
      </p>
    )}

    {!loadingTickets && tickets.length === 0 && (
      <p className="text-sm text-muted-foreground">
        No support tickets found.
      </p>
    )}

     {!loadingTickets &&
      tickets.map((ticket) => (
        <div
          key={ticket.ticket_uid}
          className="border border-border rounded-md p-4 bg-card"
        >
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-sm font-medium">
                {ticket.ticket_uid}
              </p>
              <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary">
                {ticket.category}
              </span>

            </div>
            <p className="text-xs text-muted-foreground">
              {new Date(ticket.created_at).toLocaleString()}
            </p>
          </div>

         <p
  className={`text-sm text-foreground whitespace-pre-wrap ${
    expandedTicket === ticket.ticket_uid
      ? ""
      : "line-clamp-2"
  }`}
>
  {ticket.message}
</p>

{ticket.message.length > 120 && (
  <button
    onClick={() =>
      setExpandedTicket(
        expandedTicket === ticket.ticket_uid
          ? null
          : ticket.ticket_uid
      )
    }
    className="text-xs text-primary mt-1 hover:underline"
  >
    {expandedTicket === ticket.ticket_uid
      ? "View less"
      : "View more"}
  </button>
)}

        </div>
      ))}

  </div>
)}

      </div>

      {/* Footer */}
      <div className="footer-section">
        <div className="legal">
          © 2026 ScatterPie Analytics Pvt. Ltd. •{" "}
          <a href="https://www.scatterpie.io/privacy-policy/">Privacy Policy</a>
        </div>
      </div>

{showConfirmModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div
      className="bg-background border border-border rounded-lg p-6 w-full max-w-md mx-4"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-lg font-semibold mb-2">
        Confirm Submission
      </h3>

      <p className="text-sm text-muted-foreground mb-6">
        Are you sure you want to submit this support ticket?
        Our team will be notified immediately.
      </p>

      <div className="flex justify-end gap-3">

        
        <button
  onClick={() => {
    setShowConfirmModal(false);
   // resetForm(); // ✅ reset page state
  }}
  className="px-4 py-2 text-sm rounded-md border border-border hover:bg-muted"
>
  Cancel
</button>


        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleSubmitTicket();
          }}
          className="px-4 py-2 text-sm rounded-md bg-primary text-primary-foreground hover:bg-primary/90"
        >
          Yes, Submit
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default SupportScreen;
